import React from 'react';

/**
 * Custom LoadingIndicator component for Blue Shield of California
 */
const CustomLoadingIndicator = () => (
  <div className="custom-loading">
    <div className="custom-spinner" />
    <div className="custom-loading-text">Loading assessment...</div>
  </div>
);

export default CustomLoadingIndicator;
